const liveURL = "https://rabbi-rabbit-2ed44ad46d75.herokuapp.com";
const testURL = "http://localhost:5000";

export { liveURL, testURL };
